"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
function InputValidated(props) {
    const errorSx = {
        border: "2px solid red",
    };
    const baseSx = {
        border: "1px solid black",
    };
    const [inputError, setInputError] = (0, react_1.useState)(null);
    const [inputSx, setInputSx] = (0, react_1.useState)(baseSx);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.TextField, { variant: "standard", type: props.type, required: true, error: inputError !== null && inputError !== void 0 ? inputError : false, label: props.placeholder, onChange: (e) => {
                props.onChange(e.target.value);
                if (e.target.validity.valid) {
                    setInputError(false);
                    setInputSx(baseSx);
                }
                else {
                    setInputError(true);
                    setInputSx(errorSx);
                }
            } })));
}
exports.default = InputValidated;
